import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import CaregiverSsnDescription from '../../../components/FormDescriptions/CaregiverSsnDescription';
import { ssnUI } from '../../../definitions/sharedUI';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['secondary-two-info-title--id'];
const INPUT_LABEL = content['secondary-two-input-label'];

const { ssn } = FULL_SCHEMA.definitions;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, CaregiverSsnDescription),
    secondaryTwoSsnOrTin: ssnUI({ label: INPUT_LABEL, type: 'ssntin' }),
  },
  schema: {
    type: 'object',
    properties: {
      secondaryTwoSsnOrTin: ssn,
    },
  },
};
